import React, { useCallback, useContext, useState } from "react";
import { Container, FormButton, H1, Main } from "../Styles/Global.Styled";
import { css } from "styled-components";
import { CartContext } from "../Context/CartContext";
import { AuthContext } from "../Context/AuthContext";
import OrderForm from "../Forms/OrderForm/OrderForm";
import { createOrder } from "../api/order";
import CartPopUp from "../Components/PopUp/CartPopUp";
import Message from "../Components/Sections/Message";
import CartItems from "../Components/OrderSummary/CartItems";
import OrderInvoice from "../Components/OrderSummary/OrderInvoice";

const mainStyle = css`
  padding: 5vh 15vw;
  align-items: center;
  gap: 3vh;
  min-height: 75vh;
`;
const mbMain = css`
  padding: 5vh 5vw;
`;
const formHeader = css`
  font-size: 2vh;
  font-weight: 400;
`;
const mbFontSize = css`
  font-size: 2.5vh;
`;
const contentCnt = css`
  width: 100%;
  align-items: flex-start;
  justify-content: space-evenly;
`;
const mbCnt = css`
  flex-direction: column-reverse;
  gap: 3vh;
  align-items: center;
`;
const step1MbCnt = css`
  flex-direction: column;
  gap: 3vh;
  align-items: center;
`;
const hideDisplay = css`
  display: none;
`;
const mobileBttnCnt = css`
  display: flex;
  position: sticky;
  bottom: 0;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 2vh;
  background-color: white;
`;
const mobileBttn = css`
  width: 30vh;
  font-size: 2vh;
`;
const cartInvoiceCnt = css`
  flex-direction: column;
  gap: 2vh;
`;
const widthStyle = css`
  width: 100%;
`;

const Checkout = ({ setPopUp, showParentToast }) => {
  const { cart } = useContext(CartContext);
  const { isLoggedIn } = useContext(AuthContext);
  const [checkoutStep, setCheckoutStep] = useState(0);
  const [orderToken, setToken] = useState("");
  const setStep = useCallback((step) => {
    setCheckoutStep(step);
  }, []);

  const orderTotal =
    Math.round(
      100 *
        cart.reduce((sum, { price, cartQuantity }) => {
          return sum + price * cartQuantity;
        }, 0)
    ) / 100;

  const handleCheckoutStep1 = async () => {
    if (!isLoggedIn) {
      setPopUp({ isOpen: true, component: <CartPopUp setPopUp={setPopUp} /> });
    }
    if (cart.some(({ error }) => error)) {
      showParentToast({
        hidden: false,
        type: "Error",
        title: "Unavailable quantity",
        text: "Please review your order.",
      });
    }
    try {
      const cartItems = cart.map(({ _id, cartQuantity, price }) => ({
        _id,
        cartQuantity,
        price,
      }));
      const cartSummary = {};
      cartSummary.sub_total = orderTotal;
      const res = await createOrder({ cartItems, cartSummary });
      console.log("createOrder res", res);
      setToken(res.orderData.token);
      setCheckoutStep(1);
    } catch (error) {
      showParentToast({
        hidden: false,
        type: "Error",
        title: "Stock error",
        text: error.message,
      });
    }
  };

  if (checkoutStep === 0) {
    return (
      <Main $baseStyle={mainStyle} $mStyle={mbMain}>
        <H1 $baseStyle={formHeader} $mStyle={mbFontSize}>
          Review your order
        </H1>
        <Container $baseStyle={contentCnt} $mStyle={step1MbCnt}>
          <CartItems isManagable />
          <OrderInvoice
            handleAction={handleCheckoutStep1}
            orderAmount={orderTotal}
          />
          {/* Mobile Stick button */}
          <Container $baseStyle={hideDisplay} $mStyle={mobileBttnCnt}>
            <FormButton
              type="button"
              $baseStyle={mobileBttn}
              onClick={() => handleCheckoutStep1()}
            >
              Checkout
            </FormButton>
          </Container>
        </Container>
      </Main>
    );
  }
  if (checkoutStep === 1) {
    return (
      <Main $baseStyle={mainStyle} $mStyle={mbMain}>
        <H1 $baseStyle={formHeader} $mStyle={mbFontSize}>
          Checkout
        </H1>
        <Container $baseStyle={contentCnt} $mStyle={mbCnt}>
          <OrderForm
            orderToken={orderToken}
            showParentToast={showParentToast}
            setStep={setStep}
          />
          <Container $baseStyle={cartInvoiceCnt} $mStyle={widthStyle}>
            <OrderInvoice
              handleAction={handleCheckoutStep1}
              orderAmount={orderTotal}
              toggle
              disabled
            />
            <CartItems toggle />
          </Container>
        </Container>
      </Main>
    );
  }
  if (checkoutStep === 2) {
    return (
      <Message
        type="success"
        header={"Your order is successsfully placed!"}
        redirectTo={"/shop"}
        message={
          <>
            We will start processing your order and update you accordingly.
            <br />
            Thank you for ordering with us!
          </>
        }
        cta={"continue shopping"}
      />
    );
  }
};

export default Checkout;
